import { createSelector } from 'reselect';
import Brand from 'records/Brand';

const getUserBrands = (state) => state.userBrands.get('data');

export const getCurrentUserBrand = createSelector(
  [getUserBrands],
  (userBrands) => {
    return Brand.getCurrentUserBrand(userBrands);
  }
);
